import { post } from '..'

export const createUploadHanlder = (url: string) => async (
  file: File,
  onUploadProgress?: (e: any) => void
) => {
  const from = new FormData()
  from.append('file', file, file.name)
  from.append('name', file.name)

  const { data } = await post(url, from, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress
  })

  return data as string
}

/**
 * 上传文件
 * @param file 文件
 * @param onUploadProgress 监听进度
 * @returns 文件名，完整路径：api/student/Files/{FileName}
 */
export const uploadFile = createUploadHanlder(`student/Files`)
